export default __webpack_public_path__ + "static/media/ceramol-acne-non-e-un-problema-1920.a2ebf939.jpg";